import React from 'react';
import styles from './form.module.css';
import useSelect from '../hooks/Useselect';
import PropTypes from 'prop-types'

const Form = ({saveCategory}) => {

	const OPTIONS = [
		{ value: 'general', label:'General'},
		{ value: 'science', label:'Ciencia'},
		{ value: 'entertainment', label:'Entretenimiento'},
		{ value: 'sports', label:'Deportes'},
		{ value: 'technology', label:'Tecnologia'},
	]


	//use hook
	const [ category, SelectNews ] = useSelect('general', OPTIONS);

	const searchNews = e => {
		e.preventDefault();
		saveCategory(category);
	}

	return ( 
		<div className={`${styles.buscador} row`}>
			<div className="col s12 m8 offset-m2">
				<form
					onSubmit={searchNews}
				>
					<h2 className={styles.heading}>Category</h2>
					<SelectNews />
					<div className="input-field col s12">
						<input 
							type="submit"
							className={`${styles.btn_block} btn-large amber darken-2`}
							value="search"
							/>
					</div>
				</form>
			</div>
		</div>
	 );
}

 
Form.propTypes = {
	saveCategory: PropTypes.func.isRequired
}
export default Form;